module.exports = __webpack_public_path__ + "img/e7b9b2d8d375ba6a3bd58dbfaeb470bf.png";